//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import { has } from "lodash";
//  -- Actions ------------------------
import { logToSentry } from "utils/networkErrorUtils";
// import { sortBy } from "lodash";
import * as SuperLessonActions from "./actions";
import axios from "axios";
import configInfo from "config"
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create Super Lesson --------------------

export const handleCreateSentenceStarter = (data) => async (dispatch) => {
  // await dispatch(SuperLessonActions.createVocabulary());
  try {
    const lessonData = await apis.post(
      "differentiation_lesson",
      `/createContent`,
      {
        body: data,
      }
    );
    if (data.id) {
      await dispatch(SuperLessonActions.updateSenteceStarter(lessonData));
    } else {
      await dispatch(SuperLessonActions.createSenteceStarter(lessonData));
    }
    return lessonData;
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'SENTENCE_STARTER',
                operation: 'CREATE_SENTENCE_STARTER'
            });
    }
  }
};



export const handleGetSentenceStarter = (data) => async (dispatch) => {
  try {
    const lessonData = await apis.post(
      "differentiation_lesson",
      `/listContent`,
      {
        body: data,
      }
    );
    await dispatch(SuperLessonActions.listSenteceStarter(lessonData));
    return lessonData;
  } catch (error) {
    if (error) {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'SENTENCE_STARTER',
                operation: 'GET_SENTENCE_STARTER'
            });
      return null;
    }
  }
};

//  -- Delete Book vocabulary ----------
export const handleDeleteSentenceStarterLesson = (id) => async (dispatch) => {
  if (!id) return;
  // dispatch(SuperLessonActions.deleteVocabulary())
  try {
    const vocabulary = await apis.del(
      "differentiation_lesson",
      `/deleteContent/${id}`
    );
    if (has(vocabulary, "id")) {
      await dispatch(SuperLessonActions.deleteSenteceStarter(vocabulary));
    }
  } catch (error) {
    if (error && error.message != "Network Error") {
      logToSentry({
                message: 'Error in operation',
                error,
                module: 'SENTENCE_STARTER',
                operation: 'DELETE_SENTENCE_STARTER_LESSON'
            });
    }
  }
};

export const handleUpdateSentenceStarter =
  (id, content) => async (dispatch) => {
    if (!id) return;
    try {
      const superlession = await apis.post(
        "differentiation_lesson",
        `/updateContentSentenceStarter`,
        {
          body: {
            id,
            content,
          },
        }
      );
      if (superlession && superlession.success) {
        await dispatch(
          SuperLessonActions.updateSenteceStarter(superlession.data)
        );
      }
      return superlession;
    } catch (error) {
      if (error && error.message !== "Network Error") {
        logToSentry({
                message: 'Error in operation',
                error,
                module: 'SENTENCE_STARTER',
                operation: 'CREATE_SENTENCE_STARTER'
            });
      }
    }
    return null;
  };
